<app-ds-generic-card
  [space]="genericCardSpaces.None">
  <div class="content-box">
    <div class="content-text">
      <span class="title">
        {{ 'FREE_CANCELLATION.PUBLICITY.TITLE' | transloco }}
      </span>
      <span class="description" [innerHTML]="'FREE_CANCELLATION.PUBLICITY.DESCRIPTION' | transloco"></span>
      <ng-container *ngIf="showDisabledAirlines">
        <p class="disclaimer">
          {{ 'FREE_CANCELLATION.PUBLICITY.DISCLAIMER' | transloco : { airlines: disabledAirlinesInCancellation | listAirlineNames | async } }}
        </p>
      </ng-container>
    </div>
    <ng-template [ngTemplateOutlet]="imgTemplate"></ng-template>
  </div>
</app-ds-generic-card>

<ng-template #imgTemplate>
  <img class="logo" loading="lazy" [src]="refundableImage | ImageCdn">
</ng-template>

<ng-template #greenBoxTemplate>
  <div class="green-box">
    <i aria-hidden="true" class="icon-time"></i>
    <div class="circ"></div>
  </div>
</ng-template>
